// React import
import { useState } from 'react';

// Material UI import
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

// Font Awesome import
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Component import
import RatesDetails from '../../RatesDetails.js';
import { RateCard } from '../../RateCard.js';

function SidePaneRfqsDrawer(props) {
    const { onClose, setMinimizedSearch, rates, org, exchangeRates, emphasize, prefix, epilogue, transportationMethod, products, onReparseSource, reparsingSourceId } = props;
    const theme = useTheme();
    return (
        <Box sx={{ width: '100%', paddingBottom: '24px', overflowY: 'auto' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', background: 'transparent', padding: '6px 24px', mb: 3, borderBottom: '1px solid rgba(59, 130, 246, 0.3)', boxShadow: 'none' }}>
                <Typography variant='body1' sx={{ fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#334155' }}>
                    RFQs to Suppliers
                </Typography>
                <IconButton color='inherit' onClick={onClose} sx={{ fontSize: '13px', gap: '6px', borderRadius: '6px' }}>
                    <FontAwesomeIcon icon={faArrowLeft} /> Back
                </IconButton>
            </Box>
            <Box sx={{ padding: '0px 24px' }}>
                {prefix}
                {(rates || []).map(r => (
                    <Box key={r.id} sx={{ paddingBottom: '24px' }}>
                        {r.source && (
                            <Box sx={{ marginBottom: '30px' }}>
                                <RateCard
                                    organization={org}
                                    rate={r}
                                    exchangeRates={exchangeRates}
                                    transitDatesIndex={0}
                                    onStartDragging={() => setMinimizedSearch(true)}
                                    onEndDragging={() => setMinimizedSearch(false)}
                                    standaloneWithDragging={true}
                                    opportunityProducts={products}
                                />
                            </Box>
                        )}
                        <RatesDetails
                            organization={org}
                            rates={[r]}
                            emphasize={emphasize}
                            onStartDragging={() => setMinimizedSearch(true)}
                            onEndDragging={() => setMinimizedSearch(false)}
                            transportationMethod={transportationMethod}
                            opportunityProducts={products}
                            onReparseSource={onReparseSource}
                            reparsingSource={reparsingSourceId === r.id}
                        />
                    </Box>
                ))}
                {epilogue && (
                    <Box sx={{ paddingTop: '24px' }}>
                        {epilogue}
                    </Box>
                )}
            </Box>
        </Box>
    )
}

export default SidePaneRfqsDrawer;
